import React from 'react';

import MaintenanceManagement from './components/MaintenanceManagement';

/**
 * function component
 */
function Management() {
  return (
    <div className="maintenance-schedule-warp">
      <div className="content">
        <MaintenanceManagement />
      </div>
    </div>
  );
}

export default Management;
